// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import { formikInjectedPropsTypes } from '../../../lib/validation/propTypes/formikPropTypes';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { Trans, CreditCardIcon, InputNumeric } from '../..';
import InputWrapper from '../../common/Forms/Inputs/InputWrapper';
import { TextButton } from 'texkit/dist/components/Buttons';

// Actions
import { openModal } from '../../../reducers/modal/modalActions';

// Helpers
import { paymentAccountsData } from '../../../lib/data';
import { formatExpirationDate, getIsAmexAccepted } from '../../../lib/helpers';
import { selectAppSlugByPath } from '../../../reducers/agency/agencySelectors';

const PaymentCard = ({
  className,
  paymentAccount = {},
  showCvv,
  formikProps,
  showEditButton,
  isCardExpired,
  onEdit = () => {},
}) => {
  const dispatch = useDispatch();
  const currentAppSlug = useSelector(selectAppSlugByPath);
  const { cardType, cardLast4, expirationDate } = paymentAccount;
  let fontStyle = '';

  const handleWhatsThisClick = () => {
    const showAmex = getIsAmexAccepted(currentAppSlug);
    dispatch(openModal('WhatsThisModal', { showAmex }));
  };

  const dangerTextColor = isCardExpired ? 'text-danger' : '';

  return (
    <>
      <div className={classnames('payment-card', className)}>
        <CreditCardIcon
          name={
            cardType && paymentAccountsData[cardType]
              ? paymentAccountsData[cardType].icon
              : ''
          }
        />
        <div className="payment-card-info">
          <div className="payment-card-column">
            <div
              className={`${fontStyle} payment-card-number ${dangerTextColor}`}
            >
              •••&nbsp;{cardLast4}
            </div>
            <span
              className={`${fontStyle} payment-card-name ${dangerTextColor}`}
            >
              {cardType && paymentAccountsData[cardType]
                ? paymentAccountsData[cardType].name
                : ''}
            </span>

            <span
              className={`${fontStyle} payment-card-expiration ${dangerTextColor}`}
            >
              {isCardExpired ? (
                <Trans file="Todo" id="TodoListState_Expired" />
              ) : (
                <Trans file="Todo" id="TodoListState_Todo" />
              )}{' '}
              {formatExpirationDate(expirationDate)}
            </span>
          </div>
        </div>
      </div>
      <div className="update-payment-button">
        {showEditButton && (
          <TextButton
            type="button"
            onClick={() => onEdit(paymentAccount)}
            className="button-link line-height-1-5"
            // DFCT0035994 - ADA ISSUE
            aria-label={`Update card information for ${cardType} ending in ${cardLast4}`}
          >
            <Trans
              file="Payment"
              id="UpdateCardInformation"
              fallback="Update card information"
            />
          </TextButton>
        )}
      </div>
      {showCvv && (
        // DFCT0035994 - ADA ISSUE
        <>
          <InputWrapper
            className="payment-card-security-code input-numeric"
            name="cvv"
            type="text"
            label={<Trans file="Payment" id="SecurityCode" />}
            labelPosition="above"
            minLength="3"
            maxLength="4"
            required={true}
            formikProps={formikProps}
            //hint property used by the inputWrapper to set autoComplete off
            hint={{ onFocusOnly: true }}
            // DFCT0035994 - ADA ISSUE
            aria-label="Security code or CVV for selected card"
          />
          <button
            // DFCT0035994 - ADA ISSUE
            type="button"
            onClick={handleWhatsThisClick}
            // DFCT0035994 - ADA ISSUE
            aria-label="What is this security code? Click for more information"
            className="button-link"
          >
            <Trans file="Payment" id="WhatIsThis" />
          </button>
        </>
      )}
    </>
  );
};

PaymentCard.propTypes = {
  className: PropTypes.string,
  paymentAccount: PropTypes.shape({
    paymentAccountId: PropTypes.string.isRequired,
    paymentAccountType: PropTypes.string.isRequired,
    cardNumber: PropTypes.string.isRequired,
    expirationDate: PropTypes.string.isRequired,
  }),
  showCvv: PropTypes.bool.isRequired,
  formikProps: formikInjectedPropsTypes.isRequired,
  showEditButton: PropTypes.bool,
  onEdit: PropTypes.func,
  isCardExpired: PropTypes.bool,
};

export default PaymentCard;
